<template>
  <div v-if="showComponent">
    <vs-card class="mt-4 mb-4">
      <div slot="header">
        <h3>Reparo do Veículo</h3>
      </div>
      <div>
        <div class="vx-row">
          <!-- Vistoriador -->
          <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
            <label class="vs-select--label">Vistoriador</label>
            <v-select
              class="selectStyle"
              :options="listVistoriadores"
              name="Vistoriador"
              id="Vistoriador"
              v-model="formReparoVeiculo.idVistoriador"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>

          <!-- Veículo na oficina -->
          <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
            <label class="vs-input--label">Veículo já está na oficina?</label>
            <vs-switch
              v-model="formReparoVeiculo.veiculoEmOficina"
              color="success"
              class="mt-2 ml-2"
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- Data de Entrada -->
          <div class="vx-col lg:w-1/3 xl:w-1/6 w-full mb-2">
            <InputDate
              v-model="formReparoVeiculo.dataEntrada"
              label="Data de Entrada"
              name="Data de Entrada"
              :disabled="!formReparoVeiculo.veiculoEmOficina"
            />
          </div>

          <!-- Previsão de saída -->
          <div class="vx-col lg:w-1/3 xl:w-1/6 w-full mb-2">
            <InputDate
              v-model="formReparoVeiculo.dataPrevisaoSaida"
              label="Previsão de Saída"
              name="Previsão de Saída"
              :disabled="!formReparoVeiculo.veiculoEmOficina"
            />
          </div>

          <!-- Data de saída oficial -->
          <div class="vx-col lg:w-1/3 xl:w-1/6 w-full mb-2">
            <InputDate
              v-model="formReparoVeiculo.dataSaidaOficial"
              label="Data de Saída Oficial"
              name="Data de Saída Oficial"
              :disabled="!formReparoVeiculo.veiculoEmOficina"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <label class="vs-select--label">Comprador de Peças</label>
            <v-select
              class="selectStyle"
              :options="responsibleList"
              label="label"
              name="Comprador de Peças"
              v-model="formReparoVeiculo.partsBuyer"
              @option:selected="updateOficina($event)"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <label class="vs-select--label">Acompanhamento de Reparos</label>
            <v-select
              class="selectStyle"
              :options="responsibleList"
              label="label"
              name="Acompanhamento de Reparos"
              v-model="formReparoVeiculo.repairFollowUp"
              @option:selected="updateOficina($event)"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <InputDate
              v-model="formReparoVeiculo.followUpDate"
              label="Data de Acompanhamento"
              name="Data de Acompanhamento"
            />
          </div>
        </div>

        <div class="vx-row">
          <!-- Oficina -->
          <div
            class="vx-col lg:w-1/2 w-full mb-2"
            v-if="!workshopSelecionado && oficinaSelecionada"
          >
            <vs-input
              class="w-full"
              label="Oficinas Antigas"
              name="Oficinas-old"
              :disabled="true"
              v-model="oficinaFormatada"
            />
          </div>

          <div class="vx-col lg:w-1/2 w-full mb-2">
            <label class="vs-input--label">Oficinas</label>
            <v-select
              ref="workshopSelect"
              class="selectStyle"
              :options="workshopOptions"
              label="labelCompleta"
              :reduce="(item) => item"
              v-model="workshopSelecionado"
              @search="onWorkshopSearch"
              @open="attachScrollListener"
              :filterable="false"
              :clearable="true"
              :options-limit="9999"
              placeholder="Selecione uma oficina"
            />
          </div>

          <!-- Cota de Participação Terceiro (%)  -->
          <div class="vx-col lg:w-1/4 w-full mb-2" v-if="terceiro">
            <label class="vs-input--label">Cota de Part. Terceiro (%)</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formReparoVeiculo.cotaParticipacaoTerceiroPorcento"
              name="Franquia Terceiro (%)"
              v-bind="percentConfig"
            />
          </div>

          <!-- Valor da Cota de Participação -->
          <div class="vx-col lg:w-1/4 w-full mb-2" v-if="terceiro">
            <label class="vs-input--label">Valor da Franquia</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formReparoVeiculo.valorCotaParticipacaoTerceiro"
              name="Valor da Franquia"
              v-bind="moneyConfig"
            />
          </div>
        </div>

        <!-- Detalhes da oficina (Workshop) -->
        <div class="m-5" v-if="workshopSelecionado">
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Nome do Responsavel</p>
              {{ workshopSelecionado.fantasyName }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Razão Social</p>
              {{ workshopSelecionado.companyName }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Celular</p>
              {{ workshopSelecionado.telephone }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Telefone</p>
              {{ workshopSelecionado.telephone }}
            </div>
          </div>
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">CPF/CNPJ</p>
              {{ workshopSelecionado.taxId }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Rua</p>
              {{ workshopSelecionado.street }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Número</p>
              {{ workshopSelecionado.number }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Bairro</p>
              {{ workshopSelecionado.neighborhood }}
            </div>
          </div>
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">CEP</p>
              {{ workshopSelecionado.zipCode }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Estado</p>
              {{ workshopSelecionado.state }}
            </div>
          </div>
        </div>

        <!-- Detalhes da oficina -->
        <div class="m-5" v-if="!workshopSelecionado && oficinaSelecionada">
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Nome Fantasia</p>
              {{ oficinaSelecionada.nomeFantasia }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Razão Social</p>
              {{ oficinaSelecionada.razaoSocial }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Celular</p>
              {{ oficinaSelecionada.celular }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Telefone</p>
              {{ oficinaSelecionada.telefone }}
            </div>
          </div>
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">CPF/CNPJ</p>
              {{ oficinaSelecionada.cpf_cnpj }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Rua</p>
              {{ oficinaSelecionada.endereco }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Número</p>
              {{ oficinaSelecionada.numero }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Bairro</p>
              {{ oficinaSelecionada.bairro }}
            </div>
          </div>
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">CEP</p>
              {{ oficinaSelecionada.cep }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Estado</p>
              {{ oficinaSelecionada.estado }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Representante/Contato</p>
              {{ oficinaSelecionada.representanteLegal }}
            </div>
          </div>
        </div>

        <HistoricoOficinas :historicoOficinas="formReparoVeiculo.historicos" />
      </div>
    </vs-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Money } from 'v-money';
import InputDate from '../../../../../components/InputDate.vue';
import serviceEventos from '../service/index';

import HistoricoOficinas from './HistoricoOficinas.vue';

export default {
  props: ['formData', 'dominios', 'terceiro'],
  watch: {
    workshopSelecionado(workshop) {
      this.formReparoVeiculo.workshopId = workshop ? workshop.workshopId : null;
      this.oficinaSelecionada = workshop || null;
    },
    formData(value) {
      if (!value.reparoVeiculo) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - REPARO VEICULO DETALHES');
        return;
      }

      this.formReparoVeiculo = Object.assign(
        this.formReparoVeiculo,
        value.reparoVeiculo,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.reparoVeiculo = this.formReparoVeiculo;

      if (value.reparoVeiculo.idFornecedor) {
        for (let oficina of this.listOficinas) {
          if (oficina.idFornecedor === value.reparoVeiculo.idFornecedor) {
            this.oficinaSelecionada = oficina;
          }
        }
      }

      if (value.reparoVeiculo.workshopId) {
        this.getWorkshopById(value.reparoVeiculo.workshopId);
      }
    },
    'formReparoVeiculo.veiculoEmOficina': function (newValue) {
      if (newValue == false) {
        this.formReparoVeiculo.dataEntrada = null;
        this.formReparoVeiculo.dataPrevisaoSaida = null;
        this.formReparoVeiculo.dataSaidaOficial = null;
        this.formReparoVeiculo.idVistoriador = null;
        this.formReparoVeiculo.idFornecedor = null;
        this.oficinaSelecionada = null;
      }
    },
  },
  components: {
    vSelect,
    InputDate,
    Money,
    HistoricoOficinas,
  },
  data() {
    return {
      workshopOptions: [],
      workshopSearch: '',
      workshopPage: 1,
      workshopTotalPages: 1,
      isFetchingWorkshops: false,
      isLoadingWorkshops: false,
      showComponent: true,
      formReparoVeiculo: {
        idVistoriador: null,
        veiculoEmOficina: null,
        dataEntrada: null,
        dataPrevisaoSaida: null,
        dataSaidaOficial: null,
        idFornecedor: null,
        cotaParticipacaoTerceiroPorcento: 0,
        valorCotaParticipacaoTerceiro: 0,
        historicos: [],
        workshopId: null,
        partsBuyer: null,
        repairFollowUp: null,
        followUpDate: null,
      },
      listOficinas: [],
      listVistoriadores: [],
      oficinaSelecionada: null,
      workshopSelecionado: null,
      showCotaParticipacao: false,
      showDetalhesOficina: false,
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$',
        suffix: '',
        precision: 2,
      },
      percentConfig: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '%',
        precision: 0,
      },
      responsibleList: [],
    };
  },
  methods: {
    updateOficina(value) {
      if (!value) {
        this.formReparoVeiculo.idFornecedor = null;
        this.oficinaSelecionada = null;
        return;
      }

      this.formReparoVeiculo.idFornecedor = value.idFornecedor;
      this.oficinaSelecionada = value;
    },
    async getWorkshopById(workshopId) {
      try {
        const workshop = await serviceEventos.getWorkshopById(workshopId);
        this.workshopSelecionado = workshop;
      } catch (error) {
        console.error(error);
      }
    },
    async fetchWorkshops(search = '', page = 1, append = false) {
      const LIMIT_RANGE = 25
      try {
        const res = await serviceEventos.getListWorkshops(search, page, LIMIT_RANGE);
        const data = res.data || [];

        this.workshopOptions = append
          ? [...this.workshopOptions, ...data]
          : data;

        this.workshopTotalPages = res.pages;
        this.workshopPage = page;
      } catch (err) {
        console.error('Erro ao buscar workshops:', err);
      }
    },
    onWorkshopSearch(searchText) {
      this.workshopSearch = searchText;
      this.fetchWorkshops(searchText, 1, false);
    },

    async loadMoreWorkshops() {
      if (
        this.workshopPage >= this.workshopTotalPages ||
        this.isLoadingWorkshops
      ) {
        return;
      }

      this.isLoadingWorkshops = true;

      try {
        const nextPage = this.workshopPage + 1;
        await this.fetchWorkshops(this.workshopSearch, nextPage, true);
        this.workshopPage = nextPage;
      } catch (err) {
        console.error('Erro ao carregar mais workshops:', err);
      } finally {
        this.isLoadingWorkshops = false;
      }
    },

    attachScrollListener() {
      this.$nextTick(() => {
        const dropdown = this.$refs.workshopSelect.$refs.dropdownMenu;

        if (!dropdown) return;

        dropdown.removeEventListener('scroll', this.handleManualScroll);
        dropdown.addEventListener('scroll', this.handleManualScroll);
      });
    },

    handleManualScroll(event) {
      const el = event.target;
      const bottomReached =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 10;

      if (bottomReached) {
        this.loadMoreWorkshops();
      }
    },
  },
  mounted() {
    if (!this.formData.reparoVeiculo) {
      console.error('ERRO NO CONTRATO DO OBJETO - REPARO VEICULO DETALHES');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.reparoVeiculo = this.formReparoVeiculo;

    if (this.dominios) {
      this.listOficinas = this.dominios.listOficinas;
      this.listVistoriadores = this.dominios.listVistoriadores;
      this.responsibleList = this.dominios.listResponsaveis;
    }

    const FIRST_PAGE_WORKSHOPS_SELECT = 1;
    this.workshopSearch = '';
    this.fetchWorkshops('', FIRST_PAGE_WORKSHOPS_SELECT, false);
  },
  computed: {
    oficinaFormatada() {
      if (!this.oficinaSelecionada) return '';
      return `${this.oficinaSelecionada.nomeFantasia} - ${this.oficinaSelecionada.cpf_cnpj}`;
    },
  },
};
</script>

<style scoped>
.moneyStyle {
  font-size: 1rem !important;
  padding: 0.7rem !important;
}

::v-deep .vs__dropdown-menu {
  max-height: 200px !important;
  overflow-y: auto !important;
}

.inputData > input {
  width: 100%;
}

.selectStyle {
  font-size: 1rem !important;
}
</style>
